import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { textFilter } from 'react-bootstrap-table2-filter';

const tableLinkStyle = {
  margin: '0px',
  padding: '0px',
};
const FilterStyles = {
  fontSize: '14px',
  textAlign: 'center',
  display: 'inline',
  width: '100%',
};

// row.buildings is an array of buildings for the org
export function organizationBuildingFormatter(row, formatExtraData) {
  const buildingFilterValue = formatExtraData['buildingFilterValue'];
  const expandBuildingRows = formatExtraData['expandBuildingRows'];

  return (
    <>
      {row.buildings.length === 0 && <div>No Buildings</div>}
      {row.buildings.length === 1 && (
        <LinkContainer
          style={tableLinkStyle}
          to={{
            pathname: `/buildings/${row.buildings[0].id}`,
          }}
        >
          <Nav.Link>{row.buildings[0].name}</Nav.Link>
        </LinkContainer>
      )}

      {row.buildings.length > 1 && (
        <details
          open={
            (buildingFilterValue === '' ? false : true) || expandBuildingRows
          }
        >
          <summary className='et-custom-summary'>
            {row.buildings.length + ' Buildings'}
          </summary>
          {row.buildings.map((building) => (
            <div key={'building_' + building.id}>
              {building.name.toLowerCase().includes(buildingFilterValue) && (
                <LinkContainer
                  style={tableLinkStyle}
                  to={{
                    pathname: `/buildings/${building.id}`,
                  }}
                >
                  <Nav.Link>{building.name}</Nav.Link>
                </LinkContainer>
              )}
            </div>
          ))}
        </details>
      )}
    </>
  );
}

export function organizationBuildingFilter(setBuildingFilterValue) {
  return textFilter({
    placeholder: 'Filter buildings',
    style: FilterStyles,
    id: 'name',

    onFilter: (value, rows) => {
      value = value.toLowerCase();
      setBuildingFilterValue(value);
      if (value) {
        const filteredRows = rows.filter((row) => {
          let searchTerms = row.buildings.map((building) => building.name);

          searchTerms = searchTerms.map((term) =>
            term ? term.toLowerCase() : ''
          );

          let result = false;
          searchTerms.forEach((term) => {
            if (term.includes(value)) result = true;
          });
          return result;
        });
        return filteredRows;
      } else {
        return rows;
      }
    },
  });
}
